module.exports = __webpack_public_path__ + "static/awards-logo7-62d7937949ab0945f743359509b5d99b.jpg";